<template>
  <div class="row">
    <div class="col-6 mb-5 filters">
      <div class="form-field">
        <multiselect
          v-model="selectedOption"
          :allow-empty="false"
          :options="options"
          :show-labels="false"
          :searchable="true"
          track-by="id"
          label="text"
          open-direction="below"
          :max-height="540"
          :limit="300"
          :options-limit="300"
          @input="filterByLocation"
          @search-change="searchLocations">
          <template slot="clear" slot-scope="props">
            <div
              class="multiselect__clear"
              v-if="notAllOption"
              @mousedown.prevent.stop="resetFilter(props.search)">
              <i class="s7-close" />
            </div>
          </template>
        </multiselect>
      </div>
    </div>
    <VueSlimTable
      ref="table"
      :source="tableSource"
      :columns="columns"
      class='table'
      :per-page="perPage">
      <template #row="{ row }">
        <TableRow
          :row="row" :key="row.id"
          :report-configurations-url="reportConfigurationsUrl"
          :api-report-configurations-url="apiReportConfigurationsUrl"
          :can-remove-configuration="canRemoveConfiguration"
          @reportRemoved="reportRemoved" />
      </template>
    </VueSlimTable>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import snakeCaseKeys from 'snakecase-keys'
import TableRow from './table_row'
import axiosTransform from '../../../common/axios'
import { App } from '../../../common/rails'

const ALL_LOCATIONS = 'All locations'

export default {
  components: { Multiselect, TableRow },
  props: {
    reportsUrl: { type: String, required: true },
    reportConfigurationsUrl: { type: String, required: true },
    apiReportConfigurationsUrl: { type: String, required: true },
    apiOrgLocationsSearchUrl: { type: String, required: true },
    canRemoveConfiguration: { type: Boolean, required: true }
  },
  data() {
    return {
      selectedOption: { name: ALL_LOCATIONS, id: 'all' },
      options: []
    }
  },
  methods: {
    tableSource(params) {
      return axios.get(
        this.apiReportConfigurationsUrl,
        {
          params: { ...params, byLocation: this.selectedOption.id },
          paramsSerializer(json) {
            return qs.stringify(snakeCaseKeys(json, { deep: true }), { arrayFormat: 'brackets' })
          },
          ...axiosTransform
        }
      ).then((response) => response.data)
    },
    searchLocations(query) {
      return axios.get(
        this.apiOrgLocationsSearchUrl,
        {
          params: { search: query },
          ...axiosTransform
        }
      ).then((res) => {
        const fetchedOptions = res.data
        this.options = [this.selectedOption, ...fetchedOptions]
      })
    },
    filterByLocation(option) {
      this.selectedOption = option
    },
    resetFilter() {
      this.selectedOption = { name: ALL_LOCATIONS, id: 'all' }
    },
    connectToWS() {
      const channel = App.cable.subscriptions.create('GenerateReportChannel', {
        received: (data) => {
          if (data.status === 'success') {
            const reportLinks = data.report_ids.map((r) => `<a href="${this.reportsUrl}/${r}" target="_blank">${this.reportsUrl}/${r}</a>`).join('<br>')
            toastr.success(reportLinks, data.msg, { timeOut: 0 })
            this.$refs.table.refetch()
          } else {
            toastr.error(data.msg)
          }
        }
      })

      document.addEventListener('turbolinks:before-visit', () => {
        channel.unsubscribe(channel)
      })
    },
    reportRemoved(msg) {
      this.$refs.table.refetch()
      toastr.success(msg, { timeOut: 0 })
    }
  },
  watch: {
    selectedOption() {
      this.$refs.table.refetch()
    }
  },
  computed: {
    notAllOption() {
      return this.selectedOption.name !== ALL_LOCATIONS
    }
  },
  created() {
    this.perPage = 20
    this.columns = [
      { title: 'Configuration name', key: 'name' },
      { title: 'White Labeling', key: 'brand', orderable: true },
      { title: 'Locations', key: 'locations' },
      { title: 'Created At', key: 'created_at', orderable: true },
      { title: 'Last run', key: 'processed_at', orderable: true },
      { title: 'Next run', key: 'scheduled_at', orderable: true },
      { title: 'Schedule', key: 'schedule' },
      { title: 'Reports', key: 'reports_count', orderable: true },
      { title: '', key: '' }
    ]

    this.connectToWS()
    this.searchLocations()
  }
}
</script>
